import React, { useCallback, useMemo } from 'react'
import { ChatContextSourceType } from '@trustero/trustero-api-web/lib/chatcontext/chatcontext_pb'
import { ChatContext } from 'src/components/Reusable/ChatContext/useChatContext.hooks'
import { useReceptorsPermalink } from 'src/components/PageLayout/Permalink/generatePermalink'
import { ChatContextBooleanSelector } from '../chatContextPanel.components'
import { ExternalLink } from './utils.components'

export type ReceptorsModalProps = {
  show: boolean
  hide: () => void
  onBack?: () => void
  context: ChatContext
  setContext: (context: ChatContext) => void
}

export const ReceptorsModal = ({
  show,
  hide,
  onBack,
  context,
  setContext,
}: ReceptorsModalProps): JSX.Element => {
  const receptorsPermalink = useReceptorsPermalink()

  const onCommit = useCallback(
    (includeAll: boolean) => {
      setContext({
        ...context,
        [ChatContextSourceType.RECEPTORS]: {
          ...context[ChatContextSourceType.RECEPTORS],
          includeAll,
        },
      })
    },
    [context, setContext],
  )

  const description = useMemo(
    () => (
      <p>
        Select if you want to consider your{' '}
        <ExternalLink to={receptorsPermalink}>receptors</ExternalLink>
      </p>
    ),
    [receptorsPermalink],
  )

  return (
    <ChatContextBooleanSelector
      title="Receptors"
      description={description}
      prompt="Do consider receptors"
      currentSelection={context[ChatContextSourceType.RECEPTORS].includeAll}
      onCommit={onCommit}
      show={show}
      hide={hide}
      onBack={onBack}
    />
  )
}
